/**
 * Build the affiliate redirect URL the frontend will navigate to.
 * Backend returns book_url like "/api/r/{item_id}". We append region from GeoContext.
 */
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export function buildAffiliateHref(bookUrl, region) {
    if (!bookUrl) return "#";
    // Already absolute? Use as-is (backwards compat).
    if (/^https?:\/\//i.test(bookUrl)) return bookUrl;
    const sep = bookUrl.includes("?") ? "&" : "?";
    const r = region || "WORLD";
    return `${BACKEND_URL}${bookUrl}${sep}region=${encodeURIComponent(r)}`;
}
